export default "__VITE_ASSET__BUXJqUBP__"